import React from "react";
import {Chart} from "react-google-charts";

export const ChartComponent = ({type, data, width, height, options, id}) => {
  return (
    <div id={id}>
      <Chart
        chartType={type}
        data={data}
        width={width}
        height={height}
        options={options}
      />
    </div>
  );
};
